import fetchApi from "ui-io/fetch-api";
import { AssetsSettingsIO } from './asset-mutation'

const assetsSettingsQuery = (pathname: string, keys: string) => ({
  queryKey: ['assetsSettings', keys],
  queryFn: () =>
    fetchApi({
      method: 'GET',
      service: 'admin-service',
      pathname:`${pathname}?keys=${keys}`,
      codec: AssetsSettingsIO,
    }),
})

export default assetsSettingsQuery
